export type Param = {
  id: number;
  key: string;
  value: string;
  deliveryZoneSettingId?: number;
  paymentMethodIntegrationId?: number;
  workFlowSettingId?: number;
};
